import React from 'react'

type Props = {
    children?: React.ReactNode;
}

const TableHead = (props: Props) => {
    return (
        <thead className="text-primary-dark text-[16px] font-bold bg-neutral-deep border-solid border-[1px] border-primary overflow-hidden">
            <tr className="h-[56px]">
                {props.children}
            </tr>
        </thead>
    )
}

export default TableHead